import { isCustomerAdmin } from "./helpers";
const SettingsPermissions = {
    settings: {
        index: (_session) => true,
    },
    "settings/company": {
        index: ({ customer, user }) => isCustomerAdmin(user, customer),
    },
    "settings/profile": {
        index: (_session) => true,
    },
    "settings/api-keys": {
        index: ({ customer, user }) => isCustomerAdmin(user, customer),
    },
};
export default SettingsPermissions;
